<!-- 已登录状态-修改密码 -->
<template>
  <div class='personal-modify-password'>
    <div class='password-wrap'>
      <div class='password-container'>
        <h3>MSP学生服务平台 忘记密码</h3>
        <Form ref="formValidate"
              :model="formValidate"
              :rules="ruleValidate"
              :label-width="0">
          <div class='base-item-item'>
            <FormItem label=""
                      prop="password">
              <Input type='password'
                     size="large"
                     v-model='formValidate.password'
                     placeholder='请输入旧密码' />
            </FormItem>
            <FormItem label=""
                      prop="newPassword">
              <Input type='password'
                     size="large"
                     v-model='formValidate.newPassword'
                     placeholder='请输入新密码' />
            </FormItem>
            <FormItem label=""
                      prop="renewPassword">
              <Input type='password'
                     size="large"
                     v-model='formValidate.renewPassword'
                     placeholder='重复新密码' />
            </FormItem>
          </div>
          <div class='oper-sub'>
            <Button href='javascript:void(0)'
                    :loading="isSub"
                    long
                    @click='modifyPassword'>修改密码</Button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import personalService from '@/api/undergraduate/personal'
import { setTimeout, clearTimeout } from 'timers'
import { setToken, setUserAvatar } from '@/libs/util'
export default {
  name: '',
  components: {},
  data () {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.formValidate.renewPassword !== '') {
          // 对第二个密码框单独验证
          this.$refs.formValidate.validateField('renewPassword')
        }
        callback()
      }
    }
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入重复新密码'))
      } else {
        if (this.formValidate.newPassword !== '' && value !== this.formValidate.newPassword) {
          callback(new Error('新密码两次输入不一致'))
        }
        callback()
      }
    }
    return {
      formValidate: {
        password: '',
        newPassword: '',
        renewPassword: ''
      },
      ruleValidate: {
        password: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { validator: validatePass, trigger: 'blur' }
        ],
        renewPassword: [
          { validator: validatePassCheck, trigger: 'blur' }
        ]
      },
      isSub: false
    }
  },
  computed: {},
  mounted () { },
  methods: {
    // 修改密码
    modifyPassword () {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)
          this.isSub = true
          personalService.changePassword(data).then(res => {
            this.$refs['formValidate'].resetFields()
            this.$ugd_message('修改密码成功', 'success')
            let timeOut = setTimeout(() => {
              clearTimeout(timeOut)
              setToken('')
              setUserAvatar('')
              this.$router.push({
                name: 'login'
              })
            }, 3000)
          }).catch(error => {
            this.$ugd_message(error.message, 'error')
          }).then(() => {
            this.isSub = false
          })
        } else {

        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
.personal-modify-password {
  padding: 20px;
  .password-wrap {
    background: #fff;
    padding: 40px 0;
    .password-container {
      width: 400px;
      margin: 0 auto;
      h3 {
        font-weight: normal;
        font-size: 20px;
        text-align: center;
        color: #323c47;
        padding: 30px 0;
      }
      .oper-sub {
        padding-top: 60px;
        button {
          display: block;
          height: 48px;
          background-image: linear-gradient(12deg, #4aa6ff 0%, #4980fd 100%);
          border-radius: 8px;
          font-size: 18px;
          color: #ffffff;
          text-align: center;
        }
      }
    }
  }
}
</style>
